module.exports = Jsw.skinUrl + "/images/logos/powered-logo.png?8700c1cdfefb55e5ddcb48027ce87d4e";